export enum EEhrKey {
  Helix = "helix",
  HelloHealth = "helloHealth",
  Iris = "iris",
  BestPractice = "bestPractice",
}
